import { render, staticRenderFns } from "./EditarMembresia.vue?vue&type=template&id=897024c8"
import script from "./EditarMembresia.vue?vue&type=script&lang=js"
export * from "./EditarMembresia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports